import { NgModule } from '@angular/core';
import { InteractiveTableModule } from '../list/interactive-table';
import { FixedDataTableComponent } from './fixed-data-table.component';


@NgModule({
  imports: [
    InteractiveTableModule
  ],
  declarations: [
    FixedDataTableComponent
  ],
  exports: [
    FixedDataTableComponent
  ],
  providers: [
  ]
})
export class FixedDataTableModule {}
